// extracted by mini-css-extract-plugin
export default {"root":"CrossButton_root__RNbwp"};